export enum ActionEnum {
  Checkout = "Checkout",
  Pay = "Pay",
  Decide = "Decide",
  Approve = "Approve",
  Reject = "Reject",
  Update = "Update",
  Complete = "Complete",
  CompleteScan = "CompleteScan",
  ScanComplete = "ScanComplete",
  Upload = "Upload",
  NewQr = "NewQr",
  New = "New",
  Delete = "Delete",
  Cancel = "Cancel",
  Print = "Print",
  PrintWaiver = "PrintWaiver",
  PrintQr = "PrintQr",
  NewEmployee = "New Employee",
  Process = "Process",
  ChangeBucket = "ChangeBucket",
  TemporaryTransfer = "TemporaryTransfer",
}
